import { ActiveUserItem } from './dashboardApi';

export interface ActiveUserEntry {
  id: number;
  username: string;
  messageCount: number;
  rank: number;
}

export const buildActiveUsersList = (users: ActiveUserItem[]): ActiveUserEntry[] => {
  if (!Array.isArray(users)) {
    return [];
  }

  return [...users]
    .sort((a, b) => {
      if (a.rank && b.rank) {
        return a.rank - b.rank;
      }
      return b.message_count - a.message_count;
    })
    .map((user, idx) => ({
      id: user.user_id ?? idx,
      username: user.username ?? 'Unknown user',
      messageCount: user.message_count ?? 0,
      rank: user.rank ?? idx + 1,
    }));
};
